import $ from 'jquery';

class CategoriesGridItem {
  constructor(element) {
    this.$element = $(element);
    this.$actionToggleModal = this.$element.find('.category-content-item-action-toggle-modal');

    this.addListeners();
  }

  addListeners() {
    this.$actionToggleModal.click(() => {
      this.cloneItemToModal();
    });
  }

  cloneItemToModal() {
    let modalContent = this.$element.find('.category-content-item-modal > .inner').clone();
    if($('#weq-modal .inner').length > 0){
      $('#weq-modal .inner').replaceWith(modalContent);
    } else {
      $('#weq-modal .weq-modal-content').append(modalContent);
    }
    $('#weq-modal').toggleClass('open');
  }
}

class Categories {
  constructor(element){
    this.$element = $(element);
    this.els = {
      navLinks : this.$element.find('.category-nav-link'),
      navItem : this.$element.find('.category-nav-item'),
      items : this.$element.find('.category-content-item'),
    };
    this.$categoriesItems = this.$element.find('.category-content-item');

    this.listeners();

    if (this.$element.hasClass('categories-component--grid')) {
      this.categoriesGridItems = [];
      for (var i = 0; i < this.$categoriesItems.length; i++) {
        let categoriesItemsElement = this.$categoriesItems[i];
        this.categoriesGridItems.push(new CategoriesGridItem(categoriesItemsElement));
      }
    }
  }

  listeners(){
    let that = this;
    this.els.navLinks.on('click', function(e){
      that.els.navLinks.removeClass('category-active');
      let $target = $(e.target);
      that.filterCategory($target.data('category'));
      $target.addClass('category-active');
    });
  }

  filterCategory(category){
    if (category === 'all') {
      $(this.els.items).removeClass('hidden');
    }else{
      for (var i = 0; i < this.els.items.length; i++) {
        let $item = $(this.els.items[i]);
        let itemCategory = $item.data('category');
        if (itemCategory !== category) {
          $item.addClass('hidden');
        }else{
          $item.removeClass('hidden');
        }
      }
    }
  }
}

$('.categories-component').each((index, element) => {
  new Categories(element);
});
